/**
 * OrbPostMachinesWithTraitsPart1VisionSLPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbPostMachinesWithTraitsPart1VisionSLPostPage
 */

import { useOrbPostMachinesWithTraitsPart1VisionSLPostPageLogic } from '@/hooks/traits/useOrbPostMachinesWithTraitsPart1VisionSLPostPageLogic';
import type { OrbPostMachinesWithTraitsPart1VisionSLPostPageConfig } from '@/hooks/traits/useOrbPostMachinesWithTraitsPart1VisionSLPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbPostMachinesWithTraitsPart1VisionSLPostView as OrbPostMachinesWithTraitsPart1VisionSLPostViewEntity } from '@app/shared';
import { Box } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { OrbPostMachinesWithTraitsPart1VisionSLPostFooterView } from '@/components/traits/OrbPostMachinesWithTraitsPart1VisionSLPostFooterView';
import { OrbPostMachinesWithTraitsPart1VisionSLPostHeaderView } from '@/components/traits/OrbPostMachinesWithTraitsPart1VisionSLPostHeaderView';
import { OrbPostMachinesWithTraitsPart1VisionSLPostView } from '@/components/traits/OrbPostMachinesWithTraitsPart1VisionSLPostView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbPostMachinesWithTraitsPart1VisionSLPostPageViewProps {
  config?: Partial<OrbPostMachinesWithTraitsPart1VisionSLPostPageConfig>;
}

export function OrbPostMachinesWithTraitsPart1VisionSLPostPageView({ config: propsConfig }: OrbPostMachinesWithTraitsPart1VisionSLPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbPostMachinesWithTraitsPart1VisionSLPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbPostMachinesWithTraitsPart1VisionSLPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbPostMachinesWithTraitsPart1VisionSL" trait="OrbPostMachinesWithTraitsPart1VisionSLPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbPostMachinesWithTraitsPart1VisionSLPostPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbPostMachinesWithTraitsPart1VisionSLPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box bg="transparent" fullWidth={true} paddingY="xl"><Container maxWidth="xl" padding="lg" size="xl"><OrbPostMachinesWithTraitsPart1VisionSLPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><OrbPostMachinesWithTraitsPart1VisionSLPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbPostMachinesWithTraitsPart1VisionSLPostPageView;
